import { render, staticRenderFns } from "./digital.vue?vue&type=template&id=6f8b9e62&"
import script from "./digital.vue?vue&type=script&lang=js&"
export * from "./digital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports